
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';



@Injectable({
    providedIn: 'root'
})

export class ConnectionService {


    constructor(private http: HttpClient) {
    }


  protected CallApi(method, api, param, headers: HttpHeaders, sucFun, errFun) {
        // this.loader.start('default')
        switch (method) {
            case "get":
                this.http.get(api, {
                    params: param, headers: headers
                })
                    .subscribe(
                        res => { sucFun(res) },
                        err => { errFun(err) }
                    );
                break;
            case "post":
            this.http.post(api, param, { headers })
                    .subscribe(
                        res => { sucFun(res) },
                        err => { errFun(err) }
                    );
                break;

            case "put":
            this.http.put(api, param, { headers })
                    .subscribe(
                        res => { sucFun(res) },
                        err => { errFun(err) }
                    );
                break;
        }

    }
}
